import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Auth from '@/store/auth';
import SearchState from '@/store/search';
import { NotFoundMessage } from '@/constants/util';
import Portal from '../views/Portal.vue';
import CustomerRegister from '../views/CustomerRegister.vue';
import CustomerList from '../views/CustomerList.vue';
import CustomerEdit from '../views/CustomerEdit.vue';
import MatterList from '../views/MatterList.vue';
import Signin from '../views/Signin.vue';
import Forget from '../views/Forget.vue';
import ResetPassword from '../views/ResetPassword.vue';
import NotFound from '../views/NotFound.vue';
import EstimateRegister from '../views/EstimateRegister.vue';
import EstimateEdit from '../views/EstimateEdit.vue';
import MatterRegister from '../views/MatterRegister.vue';
import MatterEdit from '../views/MatterEdit.vue';
import CustomerDepartmentRegister from '../views/CustomerDepartmentRegister.vue';
import CustomerDepartmentEdit from '../views/CustomerDepartmentEdit.vue';
import SettingEmployeeList from "../views/SettingEmployeeList.vue";
import SettingEmployeeRegister from "../views/SettingEmployeeRegister.vue";
import SettingEmployeeEdit from "../views/SettingEmployeeEdit.vue";
import SettingManagementView from "../views/SettingManagementView.vue";
import DataExportOutput from '../views/DataExportOutput.vue';
import DataExportSellingOrganization from '../views/DataExportSellingOrganization.vue';
import DataExportSellingRepresentative from '../views/DataExportSellingRepresentative.vue';
import MaterialTemplateList from '../views/MaterialTemplateList.vue';
import MaterialTemplateEdit from '../views/MaterialTemplateEdit.vue';
import MaterialTemplateRegister from '../views/MaterialTemplateRegister.vue';
import InformationRegister from '../views/InformationRegister.vue';
import InformationList from '../views/InformationList.vue';
import InformationEdit from '../views/InformationEdit.vue';

Vue.use(VueRouter);

const requiresAuthFlag = true;

const routes: Array<RouteConfig> = [
  {
    path: '/signin',
    name: 'Signin',
    component: Signin
  },
  {
    path: '/signin/forget',
    name: 'Forget',
    component: Forget
  },
  {
    path: '/signin/reset_password/:token',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '/',
    name: 'Portal',
    component: Portal,
    meta: {
      title: 'ポータルページ',
      breadcrumbs: [
        {
          name: 'ポータルページ'
        }
      ],
      requiresAuth: requiresAuthFlag
    }
  },
  {
    path: '/customer/list',
    name: 'CustomerList',
    component: CustomerList,
    meta: {
      title: '顧客検索',
      breadcrumbs: [
        {
          name: '顧客検索'
        }
      ],
      requiresAuth: requiresAuthFlag
    }
  },
  {
    path: '/customer/register',
    name: 'CustomerRegister',
    component: CustomerRegister,
    meta: {
      title: '顧客登録',
      breadcrumbs: [
        {
          name: '顧客管理'
        },
        {
          name: '顧客登録'
        }
      ],
      requiresAuth: requiresAuthFlag
    }
  },
  {
    path: '/customer/edit/:id',
    name: 'CustomerEdit',
    component: CustomerEdit,
    meta: {
      title: '顧客詳細',
      breadcrumbs: [
        {
          name: '顧客管理'
        },
        {
          name: '顧客詳細'
        }
      ],
      requiresAuth: requiresAuthFlag
    }
  },
  {
    path: '/customer/departmentregister/:id',
    name: 'CustomerDepartmentRegister',
    component: CustomerDepartmentRegister,
    meta: {
      title: '顧客部署登録',
      breadcrumbs: [
        {
          name: '顧客管理'
        },
        {
          name: '顧客部署登録'
        }
      ],
      requiresAuth: requiresAuthFlag
    }
  },
  {
    path: '/customer/departmentedit/:id',
    name: 'CustomerDepartmentEdit',
    component: CustomerDepartmentEdit,
    meta: {
      title: '顧客部署詳細',
      breadcrumbs: [
        {
          name: '顧客管理'
        },
        {
          name: '顧客部署詳細'
        }
      ],
      requiresAuth: requiresAuthFlag
    }
  },
  {
    path: '/estimate/register/:id',
    name: 'EstimateRegister',
    component: EstimateRegister,
    meta: {
      title: '見積登録',
      breadcrumbs: [
        {
          name: '見積登録'
        }
      ],
      requiresAuth: requiresAuthFlag
    }
  },
  {
    path: '/estimate/edit/:datastoreId/:id',
    name: 'EstimateEdit',
    component: EstimateEdit,
    meta: {
      title: '見積詳細',
      breadcrumbs: [
        {
          name: '見積'
        },
        {
          name: '見積詳細'
        }
      ],
      requiresAuth: true
    }
  },
  {
    path: '/matter/list',
    name: 'MatterList',
    component: MatterList,
    meta: {
      title: '案件検索',
      breadcrumbs: [
        {
          name: '案件検索'
        }
      ],
      requiresAuth: requiresAuthFlag
    }
  },
  {
    path: '/matter/register/:id',
    name: 'MatterRegisterWithId',
    component: MatterRegister,
    meta: {
      title: '案件登録',
      breadcrumbs: [
        {
          name: '案件登録'
        }
      ],
      requiresAuth: requiresAuthFlag
    }
  },
  {
    path: '/matter/register',
    name: 'MatterRegister',
    component: MatterRegister,
    meta: {
      title: '案件登録',
      breadcrumbs: [
        {
          name: '案件登録'
        }
      ],
      requiresAuth: requiresAuthFlag
    }
  },
  {
    path: '/matter/edit/:id',
    name: 'MatterEdit',
    component: MatterEdit,
    meta: {
      title: '案件詳細',
      breadcrumbs: [
        {
          name: '案件詳細'
        }
      ],
      requiresAuth: requiresAuthFlag
    }
  },
  {
    path: "/setting/employee/list",
    name: "SettingEmployeeList",
    component: SettingEmployeeList,
    meta: {
      title: 'ユーザーマスタ検索',
      breadcrumbs: [
        {
          name: '設定'
        },
        {
          name: 'ユーザーマスタ検索'
        },
      ],
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: "/setting/employee/register",
    name: "SettingEmployeeRegister",
    component: SettingEmployeeRegister,
    meta: {
      title: 'ユーザーマスタ登録',
      breadcrumbs: [
        {
          name: 'ユーザーマスタ検索'
        },
        {
          name: 'ユーザーマスタ登録'
        },
      ],
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: "/setting/employee/edit/:id",
    name: "SettingEmployeeEdit",
    component: SettingEmployeeEdit,
    meta: {
      title: 'ユーザーマスタ詳細',
      breadcrumbs: [
        {
          name: 'ユーザーマスタ検索'
        },
        {
          name: 'ユーザーマスタ詳細'
        },
      ],
      requiresAuth: true,
      requiresAdmin: true,
    }      
  },
  {
    path: "/information/list",
    name: "InformationList",
    component: InformationList,
    meta: {
      title: 'お知らせ情報マスタ検索',
      breadcrumbs: [
        {
          name: '設定'
        },
        {
          name: 'お知らせ情報マスタ検索'
        }
      ],
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: "/information/register",
    name: "InformationRegister",
    component: InformationRegister,
    meta: {
      title: 'お知らせ情報マスタ登録',
      breadcrumbs: [
        {
          name: 'お知らせ情報マスタ検索'
        },
        {
          name: 'お知らせ情報マスタ登録'
        }
      ],
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: "/information/edit/:id",
    name: "InformationEdit",
    component: InformationEdit,
    meta: {
      title: 'お知らせ情報マスタ詳細',
      breadcrumbs: [
        {
          name: 'お知らせ情報マスタ検索'
        },
        {
          name: 'お知らせ情報マスタ詳細'
        }
      ],
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: "/setting/management",
    name: "SettingManagementView",
    component: SettingManagementView,
    meta: {
      title: '連携ファイル出力',
      breadcrumbs: [
        {
          name: '連携ファイル出力'
        },
        {
          name: '連携ファイル出力'
        },
      ],
      requiresAuth: true,
      requiresAdmin: true,
    }      
  },
  {
    path: '/dataexport/output',
    name: 'DataExportOutput',
    component: DataExportOutput,
    meta: {
      title: 'データエクスポート',
      breadcrumbs: [{ name: 'データエクスポート' }],
      requiresAuthFlag: requiresAuthFlag
    }
  },
  {
    path: '/dataexport/selling/organization',
    name: 'DataExportSellingOrganization',
    component: DataExportSellingOrganization,
    meta: {
      title: '売粗（組織）エクスポート',
      breadcrumbs: [{ name: '売粗（組織）エクスポート' }],
      requiresAuthFlag: requiresAuthFlag
    }
  },
  {
    path: '/dataexport/selling/representative',
    name: 'DataExportSellingRepresentative',
    component: DataExportSellingRepresentative,
    meta: {
      title: '売粗（担当）エクスポート',
      breadcrumbs: [{ name: '売粗（担当）エクスポート' }],
      requiresAuthFlag: requiresAuthFlag
    }
  },
  {
    path: '/materialtemplate/list',
    name: 'MaterialTemplateList',
    component: MaterialTemplateList,
    meta: {
      title: '構成表テンプレート検索',
      breadcrumbs: [{ name: '構成表テンプレート検索' }],
      requiresAuth: requiresAuthFlag
    }
  },
  {
    path: '/materialtemplate/edit/:id',
    name: 'MaterialTemplateEdit',
    component: MaterialTemplateEdit,
    meta: {
      title: '構成表テンプレート詳細',
      breadcrumbs: [{ name: '構成表テンプレート検索' }, { name: '構成表テンプレート詳細' }],
      requiresAuth: requiresAuthFlag
    }
  },
  {
    path: '/materialtemplate/register',
    name: 'MaterialTemplateRegister',
    component: MaterialTemplateRegister,
    meta: {
      title: '構成表テンプレート登録',
      breadcrumbs: [{ name: '構成表テンプレート登録' }],
      requiresAuth: requiresAuthFlag
    }
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: NotFoundMessage,
      requiresAuth: requiresAuthFlag
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

// ログイン状態を確認しログインしていない場合サインイン画面へリダイレクト
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // queryでsearchCondtions: trueを指定していない場合は保持している検索条件をクリアする
    if (SearchState.searchCondition.length > 0 && !to.query.searchConditions) {
      SearchState.clearsearchCondition();
    }
    if (!Auth.isLogin) {
      next({
        path: '/signin',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
